import constants from '../constants.js';

const HotelsList = {
  rootNode: true,
  displayName: 'Hotels',
  iconClass: 'fa-hotel',
  displayAs: constants.DISPLAY_AS.HOTEL
};

export default {
  HotelsList
}



// WEBPACK FOOTER //
// ./src/config/fields/hotels.js